import { useEffect} from 'react';
import {connect} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import { Wizard } from '../../../components/index';
import ContactosAction from '../../../store/actions/contactos';
import { Box, useTheme } from '@mui/material';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import FormPaso1CuentaExist from './FormPaso1CuentaExist';
import FormPaso2CuentaExist from './FormPaso2CuentaExist';
import TratoService from '../../../services/tratos.service';

const CuentaExistenteNuevoScreen = ({
    iniciarContacto,
    iniciarContrato
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const navigate = useNavigate();
    const location = useLocation();
    const { item,cuenta } = (location && location.state) || { };
    const options = [
        {
            title: 'Contacto',
            subtitle: 'Datos del cliente',
            icon: <AccountBoxIcon sx={{fontSize: 35}} />
        },{
            title: 'Servicios',
            subtitle: 'Servicios seleccionados',
            icon: <TaskAltIcon sx={{fontSize: 35}} />
        }
    ];
    const actualizar = async() =>{
        await TratoService.getById(item.id_t,{type:'nubicom'}).then((resp)=>{
            iniciarContrato(resp)
        })
    }
    useEffect(() => {
        if(item){
            actualizar()
        }
        document.title = 'Alta Softland';
    }, []);

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto',maxWidth:'1280px', margin: 'auto', background: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
            <Box p={2} marginBottom={0}>
                <Wizard options={options}>
                    <FormPaso1CuentaExist item={item} cuenta={cuenta} />
                    <FormPaso2CuentaExist />
                </Wizard>
            </Box>
        </Box>
    );
};

const mapStateToProps = (state) => ({
    contacto: state.contactos.current,
    contrato: state.contactos.contrato,
});

const mapDispatchToProps = (dispatch) => ({
    iniciarContacto: (data) => dispatch(ContactosAction.iniciarContacto(data)),
    iniciarContrato: (data) => dispatch(ContactosAction.iniciarContrato(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CuentaExistenteNuevoScreen);